module.exports = __webpack_public_path__ + "img/Rectangle 218.edb86311.png";